export const pump_states_t = {
  STARTUP: 0,
  IDLE: 1,
  'CHECK POWERED POLL': 2,
  'CHECK POWERED': 3,
  'WAIT BEFORE STARTING': 4,
  PRIME: 5,
  'SET SPEED': 6,
  'CHECK SPEED POLL': 7,
  'CHECK SPEED': 8,
  'SET ON': 9,
  'CHECK ON POLL': 10,
  'CHECK ON': 11,
  RUNNING: 12,
  'RUN ON': 13,
  'POWER DOWN': 14,
  'VERIFY OFF POLL': 15,
  'VERIFY OFF': 16,
  'PUMP FAULT': 17,
  'SET PRIME OFF': 18,
  'RUN ON HEARTBEAT': 19,

  0: 'STARTUP',
  1: 'IDLE',
  2: 'CHECK POWERED POLL',
  3: 'CHECK POWERED',
  4: 'WAIT BEFORE STARTING',
  5: 'PRIME',
  6: 'SET SPEED',
  7: 'CHECK SPEED POLL',
  8: 'CHECK SPEED',
  9: 'SET ON',
  10: 'CHECK ON POLL',
  11: 'CHECK ON',
  12: 'RUNNING',
  13: 'RUN ON',
  14: 'POWER DOWN',
  15: 'VERIFY OFF POLL',
  16: 'VERIFY OFF',
  17: 'PUMP FAULT',
  18: 'SET PRIME OFF',
  19: 'RUN ON HEARTBEAT',
};

export const solar_states_t = {
  OFF: 0,
  INACTIVE: 1,
  WAITING: 2,
  SAMPLING: 3,
  'SAMPLING 1': 4,
  CHECKING: 5,
  'STARTING UP': 6,
  ACTIVE: 7,
  'ACTIVE 1': 8,
  'ACTIVE 2': 9,
  LIMIT: 10,
  'WAITING 1': 11,
  'SAMPLING 2': 12,
  'ACTIVE 3': 13,
  'ACTIVE 4': 14,
  ANTIFREEZE: 15,
  'ANTIFREEZE 1': 16,
  'ANTIFREEZE 2': 17,
  _NONE: 18,

  0: 'OFF',
  1: 'INACTIVE',
  2: 'WAITING',
  3: 'SAMPLING',
  4: 'SAMPLING',
  5: 'CHECKING',
  6: 'STARTING UP',
  7: 'ACTIVE',
  8: 'ACTIVE',
  9: 'ACTIVE',
  10: 'LIMIT',
  11: 'WAITING',
  12: 'SAMPLING',
  13: 'ACTIVE',
  14: 'ACTIVE',
  15: 'ANTIFREEZE',
  16: 'ANTIFREEZE',
  17: 'ANTIFREEZE',
  18: '_NONE',
};

export const pump_triggers_t = {
  0x0001: 'RUNNING',
  0x0002: 'CHLORINATOR',
  0x0004: 'SOLAR',
  0x0008: 'INSNRG_HEATER',
  0x0010: 'HEATER',
  0x0020: 'SOLAR_TEST',
  0x0040: 'BACKWASH',
  0x0080: 'MANUAL_ON',
  0x0100: 'SPA',
  0x0200: 'ANTIFREEZE',
  0x0400: 'FILTER',
  0x0800: 'PUMP_CALL',
  0x1000: 'HEATER_2',
  0x2000: 'WATER_FEATURE',
  0x4000: 'INFLOOR',
  0x8000: 'RUN_ONCE',

  RUNNING: 0x0001,
  CHLORINATOR: 0x0002,
  SOLAR: 0x0004,
  INSNRG_HEATER: 0x0008,
  HEATER: 0x0010,
  SOLAR_TEST: 0x0020,
  BACKWASH: 0x0040,
  MANUAL_ON: 0x0080,
  SPA: 0x0100,
  ANTIFREEZE: 0x0200,
  FILTER: 0x0400,
  PUMP_CALL: 0x0800,
  HEATER_2: 0x1000,
  WATER_FEATURE: 0x2000,
  INFLOOR: 0x4000,
  RUN_ONCE: 0x8000,
};

export const appliance_status_t = {
  0: 'OFF',
  1: 'ON',
  2: 'NOT SETUP',

  OFF: 0,
  ON: 1,
  'NOT SETUP': 2,
};

export const heater_state_t = {
  0x0000: 'INIT',
  0x0001: 'CHECK TEMPERATURE',
  0x0002: 'HEATING',
  0x0003: 'HEATER RUN ON',
  0x0004: 'LIMIT',
  0x0005: 'CHECK ON',
  0x0006: 'CHECK POOL TEMPERATURE',
  0x0007: 'CHECK SPA TEMPERATURE',
  0x0008: 'STOP',
  0x0009: 'CONFIRM STOPPED',
  0x000a: 'HEATER FAULT',
  0x000b: 'RUN ON',
  0x000c: 'WAIT NEXT',

  INIT: 0x0000,
  'CHECK TEMPERATURE': 0x0001,
  HEATING: 0x0002,
  'HEATER RUN ON': 0x0003,
  LIMIT: 0x0004,
  'CHECK ON': 0x0005,
  'CHECK POOL TEMPERATURE': 0x0006,
  'CHECK SPA TEMPERATURE': 0x0007,
  STOP: 0x0008,
  'CONFIRM STOPPED': 0x0009,
  'HEATER FAULT': 0x000a,
  'RUN ON': 0x000b,
  'WAIT NEXT': 0x000c,
};

export const heater_display_state_t = {
  0x0000: 'OFF',
  0x0001: 'WAITING',
  0x0002: 'SAMPLING',
  0x0003: 'SAMPLING-CHECK',
  0x0004: 'ACTIVE',
  0x0005: 'RUN-ON',
  0x0006: 'LIMIT',
  0x0007: 'STOPPING',
  0x0008: 'HEATER FAULT',
  0x0009: 'SOLAR PRIORITY',
  0x000a: 'CHILLING',
  0x000b: 'OFF IN POOL',
  0x000c: 'OFF IN SPA',
  0x000d: 'STARTING',

  OFF: 0x0000,
  WAITING: 0x0001,
  SAMPLING: 0x0002,
  'SAMPLING-CHECK': 0x0003,
  ACTIVE: 0x0004,
  'RUN-ON': 0x0005,
  LIMIT: 0x0006,
  STOPPING: 0x0007,
  'HEATER FAULT': 0x0008,
  'SOLAR PRIORITY': 0x0009,
  CHILLING: 0x000a,
  'OFF IN POOL': 0x000b,
  'OFF IN SPA': 0x000c,
  STARTING: 0x000d,
};

export const solar_type_t = {
  NONE: 0,
  Separate: 1,
  Valve: 2,
  Boosted: 3,
  OUTRange: 4,

  0: 'NONE',
  1: 'Separate',
  2: 'Valve',
  3: 'Boosted',
  4: 'OUTRange',
};

export const thermistor_t = {
  NONE: 0,
  POOL: 1,
  ROOF: 2,
  WATER: 3,
  OUTRange: 4,

  0: 'NONE',
  1: 'POOL',
  2: 'ROOF',
  3: 'WATER',
  4: 'OUTRange',
};

export const vfTypesEnum = {
  NONE: 0,
  GAS_HEATER: 1,
  HEAT_PUMP: 2,
  SMART_HEATER: 3,
};

export const socket_types = {
  NONE: 0,
  SANITISER: 1,
  FILTER_PUMP: 2,
  CLEAN_PUMP: 3,
  BLOWER: 4,
  POOL_LIGHT: 5,
  SPA_LIGHT: 6,
  GARDEN_LIGHT: 7,
  WATER_FEATURE: 8,
  SOLAR: 9,
  OTHER: 10,
  ALWAYS_ON: 11,
  JET_PUMP: 12,
  IND_HEAT_PUMP: 13,
  UV_SANITISER: 14,
};

export const light_brand_t = {
  SINGLE_COLOUR: 0,
  ASTRAL: 1,
  AQUAQUIP: 2,
  AQUAQUIP_INSTATOUCH: 3,
  SPA_ELECTRICS: 4,
  AQUATIGHT: 5,
  SPA_ELECTRICS_MULTIPLUS: 6,
  MODLITE: 7,
  JANDY: 8,
  LED_PRO: 9,
  AQUATIGHT_SUPA: 10,
  WATERCO: 11,
  PENTAIR: 12,

  // 0: SINGLE_COLOUR,
  // 1: ASTRAL,
  // 2: AQUAQUIP,
  // 3: AQUAQUIP_INSTATOUCH,
  // 4: SPA_ELECTRICS,
  // 5: AQUATIGHT,
  // 6: SPA_ELECTRICS_MULTIPLUS,
  // 7: MODLITE,
  // 8: JANDY,
  // 9: LED_PRO,
  // 10: AQUATIGHT_SUPA,
  // 11: WATERCO,
  // 12: PENTAIR,
};
